<lib-restaurant-loader-ui [loader]="spinner.loading()" ></lib-restaurant-loader-ui>
  <div class="dashboard-layout" >

    <!-- Header (Top) -->
    <lib-header
      [isSidebarOpen]="isSidebarOpen()"
      (toggleSidebar)="toggleSidebar()"
      [userAuth]="authService.userAuth()"
    ></lib-header>

    <!-- Body (Sidebar + Content) -->
    <div class="dashboard-body">

      <!-- Sidebar -->
      <lib-sidebar
        [activeItem]="activeNav()"
        [isOpen]="isSidebarOpen()"
        (navClick)="onNavClick($event)"
        (logoutClick)="onLogout()"
      ></lib-sidebar>

      <!-- Main area -->
      <div class="dashboard-main">

      <router-outlet></router-outlet>
      
      </div>
    </div> <!-- End of dashboard-body -->
  </div> <!-- End of dashboard-layout -->
